import { render } from "./Edit.vue?vue&type=template&id=21a1a5bc&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=21a1a5bc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-21a1a5bc"

export default script